const getters = {
  visitedViews: (state: any) => state.tagsView.visitedViews,
  cachedViews: (state: any) => state.tagsView.cachedViews,
  token: (state: any) => state.user.token,
  user: (state: any) => state.user.user,
  avatar: (state: any) => state.user.user.avatar,
  name: (state: any) => state.user.user.name,
  appRoutes: (state: any) => state.permission.appRoutes,
  apps: (state: any) => state.user.apps,
  permissions: (state: any) => state.user.permissions,
  logo: (state: any) => state.user.userSettings.bannerLogo,
  settings: (state: any) => state.user.settings,
  userSettings: (state: any) => state.user.userSettings,
  drawer: (state: any) => state.user.drawer,
  unreadNotices: (state: any) => state.notices.unreadNotices,
  unreadNum: (state: any) => state.notices.unreadNum,
  app: (state: any) => state.app.current,
  appName: (state: any) => state.app.appName,
  currentApp: (state: any) => state.app.current,
  buttons: (state: any) => state.permission.buttons,
  langLibrary: (state: any) => state.i18n.langLibrary,
  routeDict: (state: any) => state.permission.routeDict,
  wmsRoutes: (state: any) => state.permission.wmsRoutes,
  lang: (state: any) => state.i18n.lang,
  materialPointDetail: (state: any) => state.app.materialPointDetail,
  cardPrintData: (state: any) => state.app.cardPrintData,
  workHistoryPrintData: (state: any) => state.app.workHistoryPrintData,
  makinoJumpValue: (state: any) => state.app.makinoJumpValue,
}
export default getters
